import { apiClient } from '@/lib/api.ts'
import type { Tenant } from '@shared/types'

export function getTenants() {
  return apiClient.get<Tenant[]>('/tenants')
}

export function reorderTenants(ids: string[]) {
  return apiClient.put('/tenants/reorder', { ids })
}

export function createTenant(data: { code: string; name: string; isPrimary: boolean }) {
  return apiClient.post<Tenant>('/tenants', data)
}

export function getTenant(tenantId: string) {
  return apiClient.get<Tenant>(`/tenants/${tenantId}`)
}

export function updateTenant(tenantId: string, data: Partial<Tenant>) {
  return apiClient.put<Tenant>(`/tenants/${tenantId}`, data)
}

export function getTenantSettings(tenantId: string) {
  return apiClient.get<Record<string, string>>(`/tenants/${tenantId}/settings`)
}

export function updateTenantSettings(tenantId: string, settings: Record<string, unknown>) {
  return apiClient.put(`/tenants/${tenantId}/settings`, settings)
}

export function syncCompanyFromSap(tenantId: string) {
  return apiClient.post<{ imported: string[]; settings: Record<string, string> }>(
    `/tenants/${tenantId}/settings/sync-company-from-sap`,
    {},
  )
}

export function getTenantAdapters(tenantId: string) {
  return apiClient.get(`/tenants/${tenantId}/adapters`)
}

export function saveTenantAdapter(
  tenantId: string,
  data: { adapter: string; label: string | null; config: Record<string, unknown>; isActive: boolean; useGlobal?: boolean },
) {
  return apiClient.put(`/tenants/${tenantId}/adapters`, data)
}

export function deleteTenantAdapter(tenantId: string, adapter: string) {
  return apiClient.delete(`/tenants/${tenantId}/adapters/${adapter}`)
}

export function getTenantTanssCategories(tenantId: string) {
  return apiClient.get(`/tenants/${tenantId}/tanss-categories`)
}

export function updateTenantTanssCategories(tenantId: string, categoryIds: string[]) {
  return apiClient.put(`/tenants/${tenantId}/tanss-categories`, { categoryIds })
}

export function getTanssCompanyCategoryTypes() {
  return apiClient.get('/tenants/tanss/company-category-types')
}
